import { Fragment } from "react";
import { Link } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";

let PromotionList = [
    {
        imgUrl: 'assets/images/promotions/01.jpg',
        imgAlt: 'Promotion Image',
        title: 'Special Festival Offer',
        price: 'Save 80%',
        desc: 'Grab this special festive promotion available for a limited time only! Don’t miss the discount.'
    },
    {
        imgUrl: 'assets/images/promotions/02.jpg',
        imgAlt: 'Promotion Image',
        title: 'Holiday Mega Sale',
        price: 'Save 70%',
        desc: 'Holiday sale is live! Get amazing discounts on top categories. Limited stock available.'
    },
    {
        imgUrl: 'assets/images/promotions/03.jpg',
        imgAlt: 'Promotion Image',
        title: 'Weekend Deal',
        price: 'Flat 70% OFF',
        desc: 'Exclusive weekend offer on selected categories. Grab the deal before it ends.'
    },
    {
        imgUrl: 'assets/images/promotions/04.jpg',
        imgAlt: 'Promotion Image',
        title: 'New Year Special',
        price: 'Save 50%',
        desc: 'Ring in the new year with exciting promotional offers and discounts.'
    },
        {
        imgUrl: 'assets/images/promotions/05.jpg',
        imgAlt: 'Promotion Image',
        title: 'Summer Art Festival',
        price: 'Save 50%',
        desc: 'Celebrate creativity with our exclusive summer art festival offers and discounts.'
    },
];

const PromotionsPage = () => {

    return (
        <Fragment>
            <Header />
            <PageHeader title={'Our Promotions'} curPage={'Promotions'} />

            <div style={{ background: "#f2f2f2", padding: "60px 0" }}>
                <div className="container text-center">

                    {/* PAGE HEADING */}
                    <h2 style={{ fontSize: "36px", fontWeight: "700", marginBottom: "10px" }}>
                        Latest Promotions
                    </h2>
                    <p style={{ maxWidth: "650px", margin: "0 auto 40px", color: "#555" }}>
                        Get the best offers, festive deals and exclusive promotions available for limited time.
                    </p>

                    <div className="row justify-content-center">

                        {PromotionList.map((val, i) => (
                            <div className="col-lg-4 col-md-6 mb-4" key={i}>
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "10px",
                                        boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                                        overflow: "hidden",
                                        transition: "0.3s",
                                        cursor: "pointer"
                                    }}
                                    className="promo-card"
                                >
                                    {/* IMAGE */}
                                    <div style={{ height: "220px", overflow: "hidden" }}>
                                        <img
                                            src={val.imgUrl}
                                            alt={val.imgAlt}
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        />
                                    </div>

                                    {/* CONTENT */}
                                    <div style={{ padding: "25px" }}>
                                        <h4 style={{ fontWeight: "700", marginBottom: "10px" }}>
                                            {val.title}
                                        </h4>

                                        <h5
                                            style={{
                                                background: "linear-gradient(45deg, #ff512f, #dd2476)",
                                                color: "#fff",
                                                display: "inline-block",
                                                padding: "6px 16px",
                                                borderRadius: "5px",
                                                marginBottom: "15px"
                                            }}
                                        >
                                            {val.price}
                                        </h5>

                                        <p style={{ color: "#555", minHeight: "60px" }}>
                                            {val.desc}
                                        </p>

                                        <Link
                                            to=""
                                            className="btn btn-primary"
                                            style={{
                                                background: "#ff6600",
                                                border: "none",
                                                padding: "10px 20px",
                                                borderRadius: "5px",
                                                color: "#fff",
                                                fontWeight: "600"
                                            }}
                                        >
                                            View Promotion
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
}

export default PromotionsPage;
